import { render, staticRenderFns } from "./DelegateStatute.vue?vue&type=template&id=173aafb3&"
import script from "./DelegateStatute.vue?vue&type=script&lang=ts&"
export * from "./DelegateStatute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports